import { useDispatch, useSelector } from "react-redux";
import { updateDoctor } from "../Redux/Reducers/appointmentFilterSlice";
import defaultProfile from "../assets/Male 1.svg";
import { getImage } from "../utils/api";
import { useEffect, useState } from "react";
export const DoctorCard = ({ doctor }) => {
    const dispatch = useDispatch();
    const [image, setImage] = useState();
    const { selectedDoctor } = useSelector((state) => state.appointment);
    const { primaryBackground } = useSelector((state) => state.dynamicStore);
    useEffect(() => {
        const fetchImage = async () => {
            if (doctor?.image) {
                const image = await getImage(doctor?.image);
                setImage(image);
            }
        };
        fetchImage();
    }, [doctor]);

    return (
        <div
            className=""
            onClick={async () => {
                const selectedDoctor = {
                    label: doctor?.label,
                    value: doctor?.value,
                    specialization: doctor?.specialization,
                    image: image,
                };
                dispatch(updateDoctor(selectedDoctor));
            }}
            style={{
                padding: "16px",
                boxShadow:
                    selectedDoctor?.value === doctor?.value
                        ? "0px 0px 4px 4px rgba(0, 93, 189, 0.08)"
                        : "0px 0px 4px 4px rgba(0, 0, 0, 0.08",
                borderRadius: "6px",
                minWidth: "324px",
                maxWidth: "324px",
                minHeight: '234px',
                maxHeight: '234px',
                border:
                    selectedDoctor?.value === doctor?.value
                        ? "1px solid " + primaryBackground
                        : "none",
                backgroundColor:
                    selectedDoctor?.value === doctor?.value
                        ? "rgba(229, 242, 255, 1)"
                        : "rgba(255, 255, 255, 1)",
            }}
        >
            <div className="d-flex justify-content-between">
                <div className="d-flex align-items-center justify-content-start gap-2 pb-2">
                    <div className="d-flex align-items-center justify-content-center">
                        <img
                            style={{
                                backgroundColor: "rgba(99, 143, 188, 1)",
                                border: "1px solid rgba(190, 190, 190, 1)",
                                borderRadius: "4px",
                                width: "64px",
                                height: "66px",
                                objectFit: "cover",
                            }}
                            src={doctor.image ? image : defaultProfile}
                            alt={doctor?.label}
                        />
                    </div>
                    <div style={{ fontSize: "14px" }}>
                        <div
                            style={{
                                fontWeight: "500",
                                color: "rgba(34, 44, 54, 1)",
                            }}
                        >
                            {doctor?.label}
                        </div>
                        <div
                            className="f400-12px"
                            style={{
                                color: "rgba(84, 100, 99, 1)",
                            }}
                        >
                            {doctor?.specialization}
                        </div>
                        <span
                            className="f400-12px"
                            style={{ color: "rgba(84, 100, 99, 1)" }}
                        >
                            {doctor?.qualification}
                        </span>
                    </div>
                </div>

                <div className="d-flex align-items-center justify-content-center flex-column f500-14px" style={{boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.25)", height: "57px", width: "39px", borderRadius: "4px"}}>
                    <div className="pe-1">Exp</div>
                    <div style={{ color: "rgba(84, 100, 99, 1)" }}>
                        {doctor?.experience}Y
                    </div>
                </div>
            </div>
            <hr className="my-2"/>
            <div className="d-flex flex-column align-items-center justify-content-between f400-12px">
                <div className="d-flex align-items-start w-100">
                    <div className="w-100" style={{ color: "rgba(84, 100, 99, 1)" }}>
                        {doctor &&
                            doctor?.slot_time?.map((slot, index) => {
                                return (
                                    <div className="">
                                        <div className="f500-14px d-flex justify-content-between mb-1">
                                            <span>{slot?.facility_name}</span>
                                            <span>Fee: Rs 1500</span>
                                        </div>
                                        <div style={{ maxHeight: '100px', overflowY: 'auto',scrollbarWidth: 'thin', scrollbarColor: '#888 transparent'}}> 
                                            {slot?.data?.map((data, index) => {
                                                return (
                                                    <div className="d-flex justify-content-between align-items-center gap-2 f400-12px pb-1">
                                                        <div className="">
                                                            {data?.days.map(
                                                                (day) => {
                                                                    return (
                                                                        <span>
                                                                            {day.slice(
                                                                                0,
                                                                                3
                                                                            )}{" "}
                                                                        </span>
                                                                    );
                                                                }
                                                            )}
                                                        </div>
                                                        <div className="time-doctor">
                                                            {data?.from_time} -{" "}
                                                            {data?.to_time}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </div>
        </div>
    );
};
